import React, { useState, useEffect, useContext, useRef } from "react";
import { useDidUpdate } from '../../../hooks/useUpdate';
import { Link, useLocation } from "react-router-dom";

import axios from '../../../axios/index';

// Context
import { UserContext } from '../../Context/UserContextProvider';

// styles
// import styles from "../../Dashboard/UserManagment/UserManagment.module.css"
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css"
import pageStyles from "../UserMyAds/UserMyAds.module.css"

// components
import HomeNavbar from './../../Home/HomeNavbar/HomeNavbar';
import UserSideDashboard from '../UserSideDashboard/UserSideDashboard';
import Footer from '../../Home/Footer/Footer';
import UserManagmentChatDetailBox from '../../Dashboard/UserManagment/UserChat/UserManagmentChatDetailBox';

export default function UserChatDetail() {
    const { userToken } = useContext(UserContext);
    const { state } = useLocation();
    // console.log(state)
    const [isLoading, setIsLoading] = useState(true);
    // const [modalShow, setModalShow] = useState(false);
    const [sendMessageData, setSendMessageData] = useState({
        text: "",
        isSent: false
    })

    const inputRef = useRef(null)

    const [chatData, setChatData] = useState()

    useEffect(() => {
        if (state.recieverName) {
            const dataHandler = async () => {
                const getMessages = await axios.get(
                    `Messages/${state.id}`,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                // console.log(getMessages)
                setChatData(getMessages.data.data)
                setIsLoading(false)
            }

            dataHandler()
        }

    }, [userToken, state.id, state.recieverName])

    useDidUpdate(() => {
        if (sendMessageData.isSent) {
            const dataHandler = async () => {
                const getMessages = await axios.get(
                    `Messages/${state.id}`,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );

                setChatData(getMessages.data.data)
                // console.log(getMessages.data.data)
                setIsLoading(false)
            }
            dataHandler()
        }

    }, [sendMessageData.isSent])

    return (
        <>
            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir='rtl'>
                        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                            <HomeNavbar />
                            <div className="container py-3 px-0 mt-4">
                                <div className='w-100 d-flex justify-content-md-between justify-content-center align-items-start'>
                                    <UserSideDashboard chat />
                                    <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${pageStyles.main_container}`}>
                                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mb-5'>
                                            <div className={`my-md-0 mt-3 mb-1 ${pageStyles.title}`}>
                                                چت با مشاوران
                                            </div>
                                        </div>

                                        <UserManagmentChatDetailBox chatData={chatData} changeHandler={changeHandler} sendMessage={sendMessage} sendMessageKeyboadrd={sendMessageKeyboadrd} inputRef={inputRef} isUser />

                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                )}
        </>
    )

    function changeHandler(event) {
        setSendMessageData((prev) => {
            return { ...prev, text: event.target.value };
        });
    };

    async function sendMessage() {
        var data = new FormData();
        data.append('MessageId', chatData.id);
        data.append('Text', sendMessageData.text);
        data.append('IsSeen', false);
        const apiData = await axios.post(
            "Messages/CreateMessageContent",
            data,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        // console.log(apiData)
        if (apiData.data.isSuccess) {
            inputRef.current.value = "";
            setSendMessageData((prev) => {
                return { ...prev, isSent: true };
            });
        }
    }

    async function sendMessageKeyboadrd(event) {
        if (event.keyCode === 13) {
            if (sendMessageData.text !== "") {
                var data = new FormData();
                data.append('MessageId', chatData.id);
                data.append('Text', sendMessageData.text);
                data.append('IsSeen', false);
                const apiData = await axios.post(
                    "Messages/CreateMessageContent",
                    data,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                // console.log(apiData)
                if (apiData.data.isSuccess) {
                    inputRef.current.value = "";
                    setSendMessageData((prev) => {
                        return { ...prev, isSent: true };
                    });
                }
            }
        }
    }
}
